import * as React from "react";
const SvgCheckContainer = (props) => /* @__PURE__ */ React.createElement("svg", { width: 23, height: 23, viewBox: "0 0 23 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 1.5, y: 1.5, width: 20, height: 20, rx: 5, stroke: "#BBBBBB", strokeWidth: 1.5 }));
export default SvgCheckContainer;
